/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  static hasInitialized = false;

  constructor() {
    super();

    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('cart-form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.qtyInput = this.querySelector('[data-qty-input]');
   // this.checkAddonProducts();
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
     // Run only once on the first component instance
     if (!ProductForm.hasInitialized) {
      ProductForm.hasInitialized = true;
      this.checkAddonProducts();
    }
  }

  updateProductDetails(container, variant) {
    (variant == false) ? this.toggleAddButton('disable') : this.toggleAddButton('enable', variant.available);
    if(variant){
      if (!this.form) {
        this.updateFormVariantId(container, variant);
      }
      this.updateURLandID(variant);
      this.priceUpdate(container, variant);
      const variantMedia =
        variant.featured_media ||
        (variant.featured_image ? { preview_image: variant.featured_image } : null);
      this.updateImage(container, variantMedia);
    }
  }

  /**
   * Same product path + current page query params (e.g. view=product-abtest) with variant updated.
   */
  productUrlWithVariant(basePath, variantId) {
    const path = String(basePath || '').split('?')[0];
    const params = new URLSearchParams(window.location.search);
    params.set('variant', String(variantId));
    const q = params.toString();
    return q ? `${path}?${q}` : path;
  }

  updateFormVariantId(container, variant) {
    const input = container.querySelector('[data-dispender-buy-btn]');
    const form = input?.closest('form');

    if (form) {
      if (this.dataset.format === 'product-page') {
        window.history.replaceState({}, '', this.productUrlWithVariant(form.dataset.url, variant.id));
      }

      if (input) {
        input.value = variant.id;
      }
    }
  }

  /**
   * Get Expected to ship in from variant metafield (custom.shipping_timeframe) for line item properties
   * @param {number} variantId - Variant ID
   * @returns {string|null} - Value or null
   */
  getShippingTimeframeForVariant(variantId) {
    if (!variantId) return null;
    const custom = Utility.getVariantMetafieldsCustomFromDom(variantId, this);
    if (!custom) return null;
    return Utility.normalizeMetafieldScalar(custom.shipping_timeframe);
  }

  /**
   * Existing: variant shipping_timeframe → "Expected to ship in" (all products).
   * Water bowl only: custom.shipping_message → "Ships Separately".
   */
  applyLineItemMetafieldProperties(properties, variantId) {
    const key = String(variantId);
    let cached = this._lineItemMetafieldCache?.get(key);

    if (!cached) {
      cached = {
        shippingTimeframe: this.getShippingTimeframeForVariant(variantId),
        shipsSeparately: Utility.getShipsSeparatelyForVariant(variantId, this)
      };
      this._lineItemMetafieldCache?.set(key, cached);
    }

    if (cached.shippingTimeframe) properties['Expected to ship in'] = cached.shippingTimeframe;
    if (cached.shipsSeparately) properties['Ships Separately'] = cached.shipsSeparately;
    return properties;
  }

  buildLineItemProperties(priceEl, comparePriceEl) {
    return {
      _originalPrice: priceEl?.getAttribute('data-variant-price'),
      _compareAtPrice: comparePriceEl?.getAttribute('data-variant-compare_price') ?? priceEl?.getAttribute('data-variant-compare_price'),
      _timestamp: new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 8)
    };
  }

  pushQuantityLineItem(addItems, variantId, quantity, priceEl, comparePriceEl = priceEl) {
    const qty = Math.max(1, parseInt(quantity, 10) || 1);
    const properties = this.buildLineItemProperties(priceEl, comparePriceEl);
    this.applyLineItemMetafieldProperties(properties, variantId);
    addItems.push({ id: variantId, quantity: qty, properties });
  }

  pushUnitLineItems(addItems, variantId, quantity, priceEl, comparePriceEl = priceEl) {
    const qty = Math.max(1, parseInt(quantity, 10) || 1);
    for (let i = 0; i < qty; i++) {
      const properties = this.buildLineItemProperties(priceEl, comparePriceEl);
      this.applyLineItemMetafieldProperties(properties, variantId);
      addItems.push({ id: variantId, quantity: 1, properties: { ...properties } });
    }
  }

  /**
   * Render Price details based on current variant
   */
   priceUpdate(container,variant){
    const accessoryItems = container.querySelector('[data-accessories-item]');
    if (accessoryItems) {
      this.updateAccessoryItemsPrice(accessoryItems, variant);
    }
    const priceElement = container?.querySelector('[data-currentPrice]');
    if(!priceElement) return;

    const comparePriceElement = container?.querySelector('[data-comparePrice]');
    const discountPercentage = parseFloat(priceElement.getAttribute('data-discount-percentage'));
    let displayPrice = variant.price;
    let compareAtPrice = variant.compare_at_price;

    if (!isNaN(discountPercentage)) {
      const basePrice = variant.compare_at_price || variant.price;
      displayPrice = basePrice - (basePrice * discountPercentage / 100);
      compareAtPrice = basePrice;
    }

    priceElement.innerHTML = `${Utility.formatMoney(displayPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
    if (comparePriceElement) {
      if (!isNaN(discountPercentage) && compareAtPrice && compareAtPrice > displayPrice) {
        comparePriceElement.innerHTML = `${Utility.formatMoney(compareAtPrice, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
        comparePriceElement.classList.remove('d-none');
        comparePriceElement.style.removeProperty('display');
      } else {
        comparePriceElement.innerHTML = ` ${Utility.formatMoney(variant.compare_at_price, window.globalSpace.money_format)} ${window.globalSpace.currency_code}`;
        comparePriceElement.classList.toggle('d-none', !variant.compare_at_price || variant.compare_at_price <= 0 || variant.compare_at_price === variant.price);
      }

      var percentage_count = ((variant.compare_at_price - variant.price) * 100) /  variant.compare_at_price;
      const discountEl = container?.querySelector(".block__product-variant-discount");
      if(discountEl?.classList.contains("badge-sale-2")){
        if (discountEl) {
          discountEl.classList.remove("d-none");
          discountEl.textContent = `${percentage_count.toFixed(0)}% OFF`;
        }
      }else{
        if (discountEl) {
          discountEl.classList.remove("d-none");
          discountEl.textContent = `save ${percentage_count.toFixed(0)}%`;
        }
      }
    }else{
      const discountEl = container?.querySelector(".block__product-variant-discount");
      if (discountEl) {
        discountEl?.classList.add("d-none");
      }
    }
  }

  updateAccessoryItemsPrice(container, variant) {
    if (!variant) return;

    const priceElement = container.querySelector("[data-product-price]");
    if (!priceElement) return;

    const accessoriesWrap = container.closest('[data-accessories-wrap]');
    const variantPriceElement = container.querySelector("[data-variant-price]");
    if (!variantPriceElement) return;

    const usePlainAccessoryPrice = Utility.shouldUsePlainAccessoryPrice(accessoriesWrap, priceElement);

    let price = usePlainAccessoryPrice
      ? variant.price
      : variantPriceElement.getAttribute("data-variant-compare_price");
    let compareAtPrice = variant.compare_at_price ?? variant.price;
    if (!price && price !== 0) return;

    const originalPrice = usePlainAccessoryPrice ? variant.price : price;

    const discountPercentageAttr = usePlainAccessoryPrice
      ? null
      : priceElement.getAttribute("data-discount-percentage");
    const discountPercentage = parseFloat(discountPercentageAttr);

    if (!usePlainAccessoryPrice && !isNaN(discountPercentage)) {
      const discountAmount = price * (discountPercentage / 100);
      price -= discountAmount;
    }
    price = parseFloat(price);
    priceElement.innerHTML = `+${Utility.formatMoney(price, window.globalSpace.money_format)}`;

    const comparePriceElement = container.querySelector("[data-product-compare_price]");
    if (!comparePriceElement) return;

    let showComparePrice = false;
    let comparePriceValue = null;

    if (!usePlainAccessoryPrice && !isNaN(discountPercentage)) {
      const discountAmount = price * (discountPercentage / 100);
      if (discountAmount && discountAmount !== originalPrice) {
        showComparePrice = true;
        comparePriceValue = compareAtPrice;
      } else if (compareAtPrice && compareAtPrice !== price) {
        showComparePrice = true;
        comparePriceValue = compareAtPrice;
      }
    } else if (compareAtPrice && compareAtPrice > variant.price) {
      showComparePrice = true;
      comparePriceValue = compareAtPrice;
    } else if (!usePlainAccessoryPrice && compareAtPrice && compareAtPrice !== price) {
      showComparePrice = true;
      comparePriceValue = compareAtPrice;
    }

    if (showComparePrice && comparePriceValue != null) {
      comparePriceElement.classList.remove("d-none");
      comparePriceElement.innerHTML = Utility.formatMoney(comparePriceValue, window.globalSpace.money_format);
    } else {
      comparePriceElement.classList.add("d-none");
    }
  }

  /**
     * Toggle the button based on product availability ( add to cart / soldOut )
     * @param {Text} status enable / disable
     * @param {Boolean} variantAvailable true/false
     */
   toggleAddButton(status, variantAvailable) {
    if (!this.submitButton) return;

    // if(this.submitButton.classList.contains('block__product-has-gift-card') && document.querySelector(".block__product-custom-amount-variant")?.checked == true){
    //   document.querySelector('.block__gift-card-amount-input-block')?.classList.remove('d-none');
    // }else{
    //   document.querySelector('.block__gift-card-amount-input-block')?.classList.add('d-none');
    // }
    const addText = this.submitButton.querySelector('.add-text');
    if (status === 'disable' || (!variantAvailable)) {
      // if(this.submitButton.classList.contains('block__product-has-gift-card') && document.querySelector(".block__product-custom-amount-variant")?.checked == true){
      //   this.submitButton.removeAttribute('disabled');
      //   if (addText) addText.textContent = this.form.classList.contains('cart-upsell-form') ? window.variantStrings.upsellAddText : window.variantStrings.addToCart;
      //   const idInput = this.submitButton.closest("form")?.querySelector('input[name="id"]');
      //   const variantId = document.querySelector(".block__product-custom-amount-variant")?.getAttribute("data-option-value-id");
      //   if (idInput && variantId) {
      //     idInput.value = variantId;
      //   }
      // }else{
      // }
      this.submitButton.setAttribute('disabled', true);
      if (addText) addText.textContent = status === 'disable' ? window.variantStrings.unavailable : window.variantStrings.soldOut;
    } else {
        this.submitButton.removeAttribute('disabled');
        if (addText) addText.textContent = this.form.classList.contains('cart-upsell-form') ? window.variantStrings.upsellAddText : window.variantStrings.addToCart;
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant || !this.form) return;

    if (this.dataset.format === 'product-page') {
      window.history.replaceState({}, '', this.productUrlWithVariant(this.form.dataset.url, currentVariant.id));
    }
    this.form.querySelector('input[name="id"]').value = currentVariant.id;
  }

  /**
   * Render selected variant image/slide
   * @param {element} container
   * @param {object} variantMedia
   */
  updateImage(container, variantMedia) {
    if (!variantMedia) return;

    const preview = variantMedia.preview_image || variantMedia;
    const src = preview && preview.src;
    const imgElem = container.querySelector('[data-feauredImage]');
    const imageSlide = variantMedia.id
      ? container.querySelector(`[data-productSlider] [data-mediaID="${variantMedia.id}"]`)
      : null;

    if (imgElem && src && container.closest('[data-product-card]')) {
      imgElem.classList.remove('lozad');
      imgElem.removeAttribute('data-src');
      imgElem.removeAttribute('data-srcset');
      imgElem.removeAttribute('data-loaded');
      imgElem.removeAttribute('srcset');
      imgElem.src = src;
      if (preview.width) imgElem.setAttribute('width', String(preview.width));
      if (preview.height) imgElem.setAttribute('height', String(preview.height));
    } else if (imageSlide) {
      const slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      container.querySelector('[data-productSlider]').swiper.slideTo(slideIndex, 0, false);
    }
  }

  /**
   * Kibble / buy-now flows redirect to checkout and skip cart drawer section rendering.
   */
  shouldRedirectToCheckout() {
    if (
      window.globalSpace.template === 'product' &&
      (
        window.globalSpace.templateSuffix === 'kibble' ||
        (
          window.globalSpace.templateSuffix === 'product-abtest' &&
          this.submitButton.hasAttribute('data-buy-dispenser-main-btn')
        )
      )
    ) {
      return true;
    }

    return this.submitButton.classList.contains('block__quickview-add-to-cart');
  }

  isCartDrawerUpsellForm() {
    return (
      this.form?.classList.contains('cart-upsell-form') ||
      this.form?.classList.contains('cart-upsell-mulberry-form')
    );
  }

  resetSubmitButton() {
    this.getSubmitButtons().forEach((button) => {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    });
  }

  getSubmitButtons() {
    const buttons = [];
    if (this.submitButton) buttons.push(this.submitButton);

    const formId = this.form?.id;
    if (formId) {
      document.querySelectorAll(`button[type="submit"][form="${CSS.escape(formId)}"]`).forEach((button) => {
        if (!buttons.includes(button)) buttons.push(button);
      });
    }

    return buttons;
  }

  setSubmitButtonsLoading(isLoading) {
    this.getSubmitButtons().forEach((button) => {
      if (isLoading) {
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
      } else {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      }
    });
  }

  notifyCartBusy() {
    window.notificationEle?.updateNotification?.(
      'Cart Update',
      'Please wait for the current cart update to finish.',
      { type: 'error', timeout: 4000 }
    );
  }

  notifyCartRateLimited() {
    window.notificationEle?.updateNotification?.(
      'Cart Update',
      'Too many cart requests. Please wait a moment and try again.',
      { type: 'error', timeout: 5000 }
    );
  }

  async postCartAdd(payload, attempt = 0) {
    const response = await fetch(`${routes.cart_add_url}`, {
      ...Utility.fetchConfig(),
      body: JSON.stringify(payload)
    });
    const rawText = await response.text();

    if (response.status === 429 && attempt < 2) {
      await new Promise((resolve) => setTimeout(resolve, 1200 * (attempt + 1)));
      return this.postCartAdd(payload, attempt + 1);
    }

    if (!response.ok) {
      const rateLimited = response.status === 429;
      const error = new Error(rateLimited ? 'Cart rate limited (429)' : `Add to cart failed (${response.status})`);
      error.rateLimited = rateLimited;
      throw error;
    }

    try {
      return JSON.parse(rawText);
    } catch (parseError) {
      throw new Error('Unexpected response from cart.');
    }
  }

  refreshCartAfterAdd(dataJSON) {
    this.cartElement = document.querySelector('cart-form');
    if (!this.cartElement) {
      window.location.href = window.routes.cart_fetch_url;
      return;
    }

    if (dataJSON.sections) {
      this.cartElement._updateCart(dataJSON.sections, this.submitButton, false);
      return;
    }

    const cartElement = this.cartElement;
    const openDrawerBtn = this.submitButton;
    setTimeout(() => {
      cartElement.getCartData(openDrawerBtn);
    }, 0);
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();

    const isCartDrawerUpsell = this.isCartDrawerUpsellForm();
    this.cartElement = document.querySelector('cart-form');

    if (isCartDrawerUpsell && (AjaxCart.cartApiInFlight || this.cartElement?.isCartBusy?.())) {
      this.notifyCartBusy();
      return;
    }

    this.setSubmitButtonsLoading(true);

    if (this.form.classList.contains('cart-upsell-mulberry-form')) {
      this.submitCartUpsellMulberry(evt);
      return;
    }

    const redirectToCheckout = this.shouldRedirectToCheckout();
    let navigatingToCheckout = false;

    this._lineItemMetafieldCache = new Map();

    if (!redirectToCheckout && !isCartDrawerUpsell) {
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartToken = cart.token; // get the cart token
        // add _cartToken as a cart attribute
        if(!window.globalSpace.cartToken || window.globalSpace.cartToken != cartToken){
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                _cartToken: cartToken
              }
            })
          })
          .then(res => res.json())
          .then(updatedCart => {
            console.log('Updated cart with _cartToken:', updatedCart);
            window.globalSpace.cartToken = cartToken
          });
        }
      });
    }

    const addItems = [];
    let serializedItem = Utility.serializeForm(this.form);

    if(this.submitButton.classList.contains('block__quickview-add-to-cart')){
      const mainProductInput = document.querySelector('[data-product-section] .product-details-wrapper [data-format="product-page"] form input[name="id"]');
      const mainProductQtyInput = document.querySelector('[data-product-section] .product-details-wrapper [data-qty-container] input[name="quantity"]')?.value;
      if (mainProductInput && mainProductInput.value) {
        const additionalId = parseInt(mainProductInput.value);
        const additionalProps = {
          _originalPrice: mainProductInput.getAttribute('data-variant-price'),
          _compareAtPrice: mainProductInput.getAttribute('data-variant-compare_price'),
          _timestamp: new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 8)
        };
        this.applyLineItemMetafieldProperties(additionalProps, additionalId);
        addItems.push({ id: additionalId, quantity: mainProductQtyInput, properties: additionalProps });
      }
    }

    let qty  = serializedItem.quantity? parseInt(serializedItem.quantity) : 1;
    if(this.submitButton.classList.contains('block__product-has-gift-card')){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(this.form.closest(".product-form").querySelector('.block__gift-card-recipient-email').value == ''){
        window.notificationEle.updateNotification('Error', 'Enter your email address.', {
          type: 'error',
          timeout: 5000
        });
        this._lineItemMetafieldCache = null;
        this.resetSubmitButton();
        return;
      }else if(emailRegex.test(this.form.closest(".product-form").querySelector('.block__gift-card-recipient-email').value) == false){
        window.notificationEle.updateNotification('Error', 'Enter a valid email address.', {
          type: 'error',
          timeout: 5000
        });
        this._lineItemMetafieldCache = null;
        this.resetSubmitButton();
        return;
      }
      
      const giftCardProps = {
        _originalPrice: this.form.querySelector('input[name="id"]').getAttribute('data-variant-price'),
        _compareAtPrice: this.form.querySelector('input[name="id"]').getAttribute('data-variant-compare_price'),
        _timestamp: new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 8),
        "Recipient email": this.form.closest(".product-form")?.querySelector('.block__gift-card-recipient-email') ? this.form.closest(".product-form").querySelector('.block__gift-card-recipient-email').value : '',
        "Recipient name": this.form.closest(".product-form")?.querySelector('.block__gift-card-recipient-name') ? this.form.closest(".product-form").querySelector('.block__gift-card-recipient-name').value : '',
        "Message": this.form.closest(".product-form")?.querySelector('.block__gift-card-recipient-message') ? this.form.closest(".product-form").querySelector('.block__gift-card-recipient-message').value : '',
        "Send on": this.form.closest(".product-form")?.querySelector('.block__gift-card-recipient-send-on') ? this.form.closest(".product-form").querySelector('.block__gift-card-recipient-send-on').value : ''
      };
      this.applyLineItemMetafieldProperties(giftCardProps, parseInt(serializedItem.id));
      addItems.push({ id: parseInt(serializedItem.id), quantity: qty, properties: giftCardProps });
    }else{
      const variantInput = this.form.querySelector('input[name="id"]');
      const variantId = parseInt(variantInput?.value || serializedItem.id, 10);
      if (!Number.isFinite(variantId) || variantId <= 0) {
        window.notificationEle.updateNotification('Add to Cart', 'Please select a valid option.', {
          type: 'error',
          timeout: 5000
        });
        this._lineItemMetafieldCache = null;
        this.resetSubmitButton();
        return;
      }
      if (redirectToCheckout) {
        this.pushQuantityLineItem(addItems, variantId, qty, variantInput);
      } else {
        this.pushUnitLineItems(addItems, variantId, qty, variantInput);
      }
    }

    //addItems.push(serializedItem);
    let cartSectionID = 'component-cart-drawer';
    if(window.globalSpace.template == 'cart'){
      cartSectionID = document.getElementById('cart--items')?.dataset.id || 'template-cart';
    }
    if (!isCartDrawerUpsell && !document.querySelector('.custom-drawer.cart-drawer.open') && document.querySelectorAll("[data-dispenser-id]").length > 0) {
      document.querySelectorAll("[data-dispenser-id]").forEach(ele=>{
        if(ele.value){
          const dispenserProps = {
            _originalPrice: ele.getAttribute('data-variant-price'),
            _compareAtPrice: ele.getAttribute('data-variant-compare_price'),
            _timestamp: new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 8)
          };
          this.applyLineItemMetafieldProperties(dispenserProps, parseInt(ele.value));
          addItems.push({ id: parseInt(ele.value), quantity: 1, properties: dispenserProps });
        }
      });
    }
    
    const addToCartBtn = evt.target.querySelector('button[type=submit]');
    const isBuyDispenserMainBtn = Boolean(addToCartBtn?.hasAttribute('data-buy-dispenser-main-btn'));
    if (isBuyDispenserMainBtn && window.mulberryIntegration?.getSelectedWarrantiesForCart) {
      console.log('Mulberry cart payload', window.mulberryIntegration.getSelectedWarrantiesForCart());
      console.log('Selected Warranties', window.selectedMulberryWarranties);
    }
    if (isBuyDispenserMainBtn) { 
        document.querySelectorAll("[data-accessories-wrap]").forEach(item => {
          const checkbox = item.querySelector("[data-accessories-checkbox]");
          const qtyInput = item.querySelector("[data-qty-input]");
          const variantInput = item.querySelector("[data-upsell-variant-id]");
          if (checkbox && checkbox.checked && qtyInput && variantInput) {
            let totalQty = parseInt(qtyInput.value, 10);
            const variantId = parseInt(variantInput.value, 10);
            const isBundleAccessory = window.globalSpace.template === 'product' && window.globalSpace.templateSuffix === 'product-abtest';

            if (redirectToCheckout) {
              const accessoryProps = this.buildLineItemProperties(variantInput);
              this.applyLineItemMetafieldProperties(accessoryProps, variantId);
              if (isBundleAccessory) accessoryProps['_is_bundle_product'] = true;
              addItems.push({
                id: variantId,
                quantity: totalQty,
                properties: accessoryProps
              });
            } else {
              for (let i = 0; i < totalQty; i++) {
                const accessoryProps = this.buildLineItemProperties(variantInput);
                this.applyLineItemMetafieldProperties(accessoryProps, variantId);
                if (isBundleAccessory) accessoryProps['_is_bundle_product'] = true;
                addItems.push({
                  id: variantId,
                  quantity: 1,
                  properties: accessoryProps
                });
              }
            }
          }
        });
        window.mulberryIntegration?.syncCareWarrantySelections?.();
        window.mulberryIntegration?.syncWarrantyOfferIdsToDom?.();

        document.querySelectorAll('[data-warranty-wrap]').forEach((item) => {
          const checkbox = item.querySelector('[data-warranty-checkbox]');
          const warrantyVariantInput = item.querySelector('[data-warranty-variant-id]');
          if (!checkbox?.checked || !warrantyVariantInput?.value) return;
          
          // Check for new warranty data structure with quantities
          const warrantyVariantDataAttr = warrantyVariantInput.getAttribute('data-warranty-variant-data');
          let warrantyVariantData = [];
          
          if (warrantyVariantDataAttr) {
            try {
              warrantyVariantData = JSON.parse(warrantyVariantDataAttr);
            } catch (e) {
              console.error('Failed to parse warranty variant data:', e);
            }
          }
          
          // If no new data structure, fall back to single warranty
          if (warrantyVariantData.length === 0) {
            const warrantyVariantId = parseInt(warrantyVariantInput.value, 10);
            if (!Number.isNaN(warrantyVariantId)) {
              warrantyVariantData = [{
                variantId: warrantyVariantId,
                quantity: 1,
                unitPrice: parseInt(warrantyVariantInput.getAttribute('data-variant-price') || '0', 10),
                series: 'unknown'
              }];
            }
          }
          
          warrantyVariantData.forEach((warrantyData) => {
            const warrantyVariantId = parseInt(warrantyData.variantId, 10);
            if (Number.isNaN(warrantyVariantId)) return;
            
            const warrantyCard = item.closest('[data-warranty-card]');
            const associatedVariantId =
              warrantyData.kibbleVariantId ||
              item.querySelector('[data-warranty-associated-variant-id]')?.value ||
              warrantyCard?.getAttribute('data-warranty-associated-variant-id') ||
              '';
            const kibbleVariantId = associatedVariantId ? String(associatedVariantId) : '';
            const warrantyOfferId =
              warrantyData.warrantyOfferId ||
              window.mulberryIntegration?.getWarrantyOfferIdForVariant?.(kibbleVariantId) ||
              window.selectedMulberryWarranties?.[kibbleVariantId]?.warranty_offer_id ||
              window.mulberryIntegration?.getWarrantyOfferIdFromCache?.(kibbleVariantId);
            const shippingTimeframe = this.getShippingTimeframeForVariant(warrantyVariantId);

            const warrantyProps = {
              _originalPrice: warrantyData.unitPrice,
              _compareAtPrice: warrantyData.unitPrice,
              _timestamp: new Date().toISOString() + '-' + Math.random().toString(36).substring(2, 8),
              _warranty_for_variant_id: associatedVariantId,
              _warranty_series: warrantyData.series
            };
            if (warrantyOfferId) warrantyProps['_warranty_offer_id'] = String(warrantyOfferId);
            if (shippingTimeframe) warrantyProps['Expected to ship in'] = shippingTimeframe;

            const warrantyItem = {
              id: warrantyVariantId,
              quantity: warrantyData.quantity || 1,
              properties: warrantyProps
            };
            // Nested cart line (Ajax Cart API): the parent dispenser is added in this SAME request,
            // so link the child by parent_id = the parent line's variant id. Top-level param, not a property.
            const warrantyParentId = parseInt(associatedVariantId, 10);
            if (!Number.isNaN(warrantyParentId)) warrantyItem.parent_id = warrantyParentId;
            addItems.push(warrantyItem);
          });
        });
    }

    const cartAddPayload = { items: addItems };
    if (!redirectToCheckout) {
      cartAddPayload.sections = `${cartSectionID},header`;
    }

    AjaxCart.cartApiInFlight = true;

    this.postCartAdd(cartAddPayload)
    .then((dataJSON) => {
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      eventBus.publish(PUB_SUB_EVENTS.productATC, {
        data: {
          item: dataJSON.items[0]
        },
      });
      document.querySelector('#PopupModal-quickshop .close-quickshop')?.dispatchEvent(new Event('click'))

      if(this.qtyInput) this.qtyInput.value = 1;

      if (redirectToCheckout) {
        navigatingToCheckout = true;
        window.location.replace('/checkout');
        return;
      }

      this.refreshCartAfterAdd(dataJSON);
      if (!isCartDrawerUpsell) {
        this.checkAddonProducts();
      }
    })
    .catch((e) => {
      if (e?.rateLimited) {
        this.notifyCartRateLimited();
      } else {
        window.notificationEle.updateNotification('Error', e?.message || String(e), {
          type: 'error',
          timeout: 5000
        });
      }
    })
    .finally(() => {
      AjaxCart.cartApiInFlight = false;
      this._lineItemMetafieldCache = null;
      if (navigatingToCheckout) return;
      this.resetSubmitButton();
    });
  };

  async submitCartUpsellMulberry(evt) {
    const cartSectionID =
      window.globalSpace.template === 'cart'
        ? document.getElementById('cart--items')?.dataset.id || 'template-cart'
        : 'component-cart-drawer';

    if (AjaxCart.cartApiInFlight || this.cartElement?.isCartBusy?.()) {
      this.notifyCartBusy();
      this.resetSubmitButton();
      return;
    }

    AjaxCart.cartApiInFlight = true;

    try {
      const addItems = await window.mulberryIntegration?.buildCartDrawerWarrantyItems(this.form);
      if (!addItems?.length) {
        window.notificationEle.updateNotification('Add to Cart', 'Unable to add Houndsy Care right now.', {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      addItems.forEach((item) => {
        this.applyLineItemMetafieldProperties(item.properties, item.id);
      });

      const dataJSON = await this.postCartAdd({
        items: addItems,
        sections: `${cartSectionID},header`
      });

      if (dataJSON.errors) {
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      eventBus.publish(PUB_SUB_EVENTS.productATC, {
        data: {
          item: dataJSON.items?.[0]
        }
      });

      this.refreshCartAfterAdd(dataJSON);
    } catch (error) {
      if (error?.rateLimited) {
        this.notifyCartRateLimited();
      } else {
        window.notificationEle.updateNotification('Error', error?.message || String(error), {
          type: 'error',
          timeout: 5000
        });
      }
    } finally {
      AjaxCart.cartApiInFlight = false;
      this.resetSubmitButton();
    }
  }

  resetAccessoryItems() {
    const noThanksCheckbox = document.getElementById('no-thanks');
    if (noThanksCheckbox) {
      noThanksCheckbox.click();
    }
  }

  resetDispenserItems() {
    const removeDispenserAnchor = document.querySelectorAll('[data-remove-dispenser');
    if (removeDispenserAnchor.length) {
      removeDispenserAnchor.forEach(item => item.click());
    }
  }

  async checkAddonProducts() {
    try {
      const upsellContainer = document.querySelector('#upsell-container');
      if (upsellContainer?.dataset.upsellProductList === 'true') {
        return;
      }

      const response = await fetch('/?sections=cart-drawer-upsell');
      const data = await response.json();
      const html = data['cart-drawer-upsell'];

      if (upsellContainer && html?.trim()) {
        upsellContainer.innerHTML = html;

        if (typeof lazyImageObserver !== 'undefined' && lazyImageObserver.observe) {
          lazyImageObserver.observe();
        }

        this.updateUpsellvariants();
      }
    } catch (error) {
      console.error('Error fetching upsell section:', error);
    }
  }
  

  updateUpsellvariants() {
    const upsellElements = document.querySelectorAll("[data-main-handle]");
    if (!upsellElements.length) return;
  
    upsellElements.forEach(ele => {
      const handle = ele.getAttribute("data-main-handle");
      const matchingItem = window.globalSpace.cart.items.find(item => item.handle === handle);
      if (!matchingItem) return;
  
      const variantOptions = matchingItem.variant_options || [];
      const opts = [
        variantOptions?.[0]?.toLowerCase() || '',
        variantOptions?.[1]?.toLowerCase() || '',
        variantOptions?.[2]?.toLowerCase() || ''
      ];

      // Handle select boxes
      const selects = ele.querySelectorAll('[data-select-box]');
      selects.forEach(select => {
        Array.from(select.options).forEach((opt, i) => {
          if (opt?.value) {
            const val = opt.value.toLowerCase();
            if (opts.some(o => o.includes(val))) {
              select.selectedIndex = i;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });
  
      // Handle radio buttons
      const radios = ele.querySelectorAll('[data-radio-box]');
      radios.forEach(radio => {
        const val = radio?.value?.toLowerCase();
        if (opts.some(opt => opt.includes(val))) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
  
          // Update UI label
          const wrapper = radio.closest("[data-main-handle]");
          const colorWrapper = wrapper?.querySelector("[data-color-label]");
          const valueEl = colorWrapper?.querySelector("[data-color-value]");
          if (valueEl) valueEl.innerText = radio.value;
        }
      });
    });

    if (document.querySelectorAll('.card-product-style-upsell').length > 0) {
      document.querySelectorAll('.card-product-style-upsell').forEach((card) => {
        const labels = card.querySelectorAll('.form-label[for]');
      
        const updateActiveLabels = () => {
          labels.forEach(label => {
            const input = document.getElementById(label.getAttribute('for'));
            label.classList.toggle('active-label', input?.checked);
          });
        };
      
        // Initial update
        updateActiveLabels();
      
        // Add change event listener to each input only once
        labels.forEach(label => {
          const input = document.getElementById(label.getAttribute('for'));
          input?.addEventListener('change', updateActiveLabels);
        });
      });
    }
  }
  
}
customElements.define('product-form', ProductForm);